import React from 'react';
import './App.css';
import { ContactUs } from 'contactus';
import "./css/ContactUs.css";
import Footer from "./modules/Footer";
import Header from './modules/Header';
import Banner from './modules/Banner';
import BannerInfo from './modules/BannerInfo';
import Testimonials from "./modules/Testimonials";
import Disclaimer from './modules/DisclaimerAndBadges'
import { CookieSetting } from "cookiesetting-component";


function App() {

  return (
    <div className="App kickin_app">
      <Header />
      <Banner />
      <BannerInfo />
      <div id='contact-wrapper'>
        <ContactUs supportEmailId="lead.management@swmc.com" phoneText="(844)786-9378" phoneNumber="tel:+18447869378" leadSource="AFPKCANCER" />
      </div>
      <Testimonials />
      <Disclaimer />
      <Footer />
      <CookieSetting
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </div>
  );
}

export default App;
